import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { Box,List,ListItem,ListItemText, SvgIcon, Typography  } from "@mui/material";
import StarRatingoComponent from "../../atom/Buttons/StarRating";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { VideoListView } from '../../atom';
import TextButtonComponet from '../../atom/Buttons/TextButton';



const QuizFirstCard = ({ icon, onclick, size,onQuizStart }) => {
    return (<Box >
    <p className='announcement-subtext' style={{marginBottom:8}}>Welcome to the Quiz!</p>
    <p className='announcement-subtext' style={{marginBottom:8}}>Hello everyone!</p>
    <p className='announcement-subtext' style={{marginBottom:15}}>We’re glad you’re here! As you take the quiz, please approach each question thoughtfully, connecting keywords and applying concepts carefully. If you find any questions confusing, use the flagging feature to mark them for review later.</p>
    <p className='announcement-subtext' style={{marginBottom:15}}>At the end, you’ll receive a detailed report with your scores for each cluster, helping you see where you excel and where you can improve.</p>

    <p className='announcement-subtext'>Good luck, and do your best! We believe in you!</p>
<Box sx={{paddingTop:5,width:{xs : 1, md: 0.2}}}>
<TextButtonComponet onButtonClick={onQuizStart} text={'Start quiz'}/> 
</Box> 
    
    </Box>);
}

export default QuizFirstCard;